import BigSingImage from './thebigsising.jpg';
import BASYLImage from './basyl.jpg';
import EmmanuelUnitedImage from './emmanuelunited.jpg';
import SiobhanMartinImage from './siobhanmartin.jpg';
import EricKaneImage from './erickane.jpg';

export const testimonials = [
  {
    name: 'thebigsing',
    src: BigSingImage,
    text: 'Our recent transition from Eventbrite to Side Door for ticketing has proven to be an outstanding decision.',
    alt: 'The Big Sing',
  },
  {
    name: 'basyl',
    src: BASYLImage,
    text: 'This is the type of experience that I would recommend for other artists... go through Side Door because you’re going to get a lot of one-on-one support.',
    alt: 'BASYL',
  },
  {
    name: 'emmanuelunited',
    src: EmmanuelUnitedImage,
    text: 'For a small, non-profit venue, it’s a game-changer for finding quality talent and nurturing emerging artists.',
    alt: 'Emmanuel United Church',
  },
  {
    name: 'siobhanmartin',
    src: SiobhanMartinImage,
    text: 'I’ve switched over to Side Door for ticketing events and couldn’t be happier!',
    alt: 'Siobhan Martin',
  },
  {
    name: 'erickane',
    src: EricKaneImage,
    text: 'Don’t rely on the system that’s in place in the music industry. I think that’s the beauty of why Side Door was created — to veer off that beaten path.',
    alt: 'Eric Kane',
  },
];
